"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initI18n = exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _reactI18next = require("react-i18next");

var initI18n = function initI18n(i18nInstance) {
  if (typeof window !== 'undefined') {
    try {
      i18nInstance.init();
      var ld = new _i18nextBrowserLanguagedetector.default(i18nInstance.services, {});

      if (ld.detect()) {
        i18nInstance.use(_i18nextBrowserLanguagedetector.default);
      }
    } catch (e) {
      console.warn('Failed to load LanguageDetector');
    }
  }

  return i18nInstance.use(_reactI18next.initReactI18next).init({
    fallbackLng: 'en'
  });
};

exports.initI18n = initI18n;
initI18n(_i18next.default);
var _default = _i18next.default;
exports.default = _default;